import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const validatePhone = (phone) => {
    return /^[\+]?[0-9]{10,15}$/.test(phone.replace(/\s/g, ""));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Full name is required and cannot be empty";
    } else if (formData.name.trim().length < 2) {
      newErrors.name = "Name must be at least 2 characters long";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email address is required";
    } else if (!validateEmail(formData.email)) {
      newErrors.email =
        "Please enter a valid email address (e.g., user@example.com)";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!validatePhone(formData.phone)) {
      newErrors.phone = "Please enter a valid phone number (10-15 digits)";
    }

    if (!formData.subject.trim()) {
      newErrors.subject = "Subject is required";
    } else if (formData.subject.trim().length < 3) {
      newErrors.subject = "Subject must be at least 3 characters long";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    } else if (formData.message.trim().length < 5) {
      newErrors.message = "Message must be at least 5 characters long";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      await emailjs.send(
        "service_nrriund", // Replace with your EmailJS service ID
        "template_vgxb6xu", // Replace with your EmailJS template ID
        {
          from_name: formData.name,
          from_email: formData.email,
          phone: formData.phone,
          subject: formData.subject,
          message: formData.message,
          to_email: "butterflyairintl@gmail.com",
        },
        "v21CGF6jYqbYG5BNO" // Replace with your EmailJS public key
      );

      toast.success(
        "🎉 Message sent successfully! We'll get back to you soon.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
      setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (error) {
      toast.error(
        "❌ Failed to send message. Please check your connection and try again.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const isDisabled = isSubmitting || !formData.message || !formData.email;

  const mapUrl = `https://maps.google.com/maps?q=${23.7307216},${90.4120346}&hl=es;&output=embed`;

  return (
    <>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div
          className="container text-center py-2"
          style={{ maxWidth: "900px" }}
        >
          <h3
            className="text-white display-3 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Contact Us
          </h3>
        </div>
      </div>
      {/* Header End */}

      {/* Contact Start */}
      <div className="container-fluid contact overflow-hidden py-5">
        <div className="container py-5">
          <div className="row g-5 mb-5">
            <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.1s">
              <div className="sub-style">
                <h5 className="sub-title text-primary pe-3">Quick Contact</h5>
              </div>
              <h1 className="display-5 mb-4">
                Have Questions? Don't Hesitate to Contact Us
              </h1>
              <p className="mb-5">
                We provide visa processing, air ticket booking, and manpower
                services with expertise and full experience, ensuring the
                fastest possible turnaround.
              </p>
              <div className="d-flex border-bottom mb-4 pb-4">
                <i className="fas fa-map-marked-alt fa-4x text-primary bg-light p-3 rounded"></i>
                <div className="ps-3">
                  <h5>Location</h5>
                  <p>Azad Center (3rd Floor), 55, Purana Paltan, Dhaka-1000</p>
                </div>
              </div>
              <div className="row g-3">
                <div className="col-xl-6">
                  <div className="d-flex">
                    <i className="fas fa-tty fa-3x text-primary"></i>
                    <div className="ps-3">
                      <h5 className="mb-3">Quick Contact</h5>
                      <div className="mb-3">
                        <h6 className="mb-0">Phone:</h6>
                        <a href="#!" className="fs-5 text-primary">
                          +8801852966938, +8801950509000
                        </a>
                      </div>
                      <div className="mb-3">
                        <h6 className="mb-0">Email:</h6>
                        <a href="#!" className="fs-5 text-primary">
                          butterflyairintl@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6">
                  <div className="d-flex">
                    <i className="fas fa-clone fa-3x text-primary"></i>
                    <div className="ps-3">
                      <h5 className="mb-3">Opening Hrs</h5>
                      <div className="mb-3">
                        <h6 className="mb-0">Saturday - Thursday:</h6>
                        <a href="#!" className="fs-5 text-primary">
                          10.00 am - 07.00pm
                        </a>
                      </div>
                      <div className="mb-3">
                        <h6 className="mb-0">Friday: Vacation </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center pt-3">
                <div className="me-4">
                  <div
                    className="bg-light d-flex align-items-center justify-content-center"
                    style={{
                      width: "90px",
                      height: "90px",
                      borderRadius: "10px",
                    }}
                  >
                    <i className="fas fa-share fa-3x text-primary"></i>
                  </div>
                </div>
                <div className="d-flex">
                  <a
                    className="btn btn-secondary border-secondary me-2 p-0"
                    href="http://www.facebook.com/ButterflyAirintl"
                  >
                    facebook <i className="fas fa-chevron-circle-right"></i>
                  </a>
                  {/* <a
                    className="btn btn-secondary border-secondary mx-2 p-0"
                    href="#!"
                  >
                    twitter <i className="fas fa-chevron-circle-right"></i>
                  </a>
                  <a
                    className="btn btn-secondary border-secondary mx-2 p-0"
                    href="#!"
                  >
                    instagram <i className="fas fa-chevron-circle-right"></i>
                  </a> */}
                </div>
              </div>
            </div>
            <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.3">
              <div className="sub-style">
                <h5 className="sub-title text-primary pe-3">Let’s Connect</h5>
              </div>
              <h1 className="display-5 mb-4">Send Your Message</h1>
              <p className="mb-3">
                We provide visa processing, air ticket booking, and manpower
                services with expertise and full experience, ensuring the
                fastest possible turnaround.
              </p>
              <form onSubmit={handleSubmit}>
                <div className="row g-4">
                  <div className="col-lg-12 col-xl-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className={`form-control ${
                          errors.name ? "is-invalid" : ""
                        }`}
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Your Name"
                        required
                      />
                      <label htmlFor="name">Your Name</label>
                      {errors.name && (
                        <div className="invalid-feedback">{errors.name}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-12 col-xl-6">
                    <div className="form-floating">
                      <input
                        type="email"
                        className={`form-control ${
                          errors.email ? "is-invalid" : ""
                        }`}
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Your Email"
                        required
                      />
                      <label htmlFor="email">Your Email</label>
                      {errors.email && (
                        <div className="invalid-feedback">{errors.email}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-12 col-xl-12">
                    <div className="form-floating">
                      <input
                        type="tel"
                        className={`form-control ${
                          errors.phone ? "is-invalid" : ""
                        }`}
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="Phone"
                        required
                      />
                      <label htmlFor="phone">Your Phone</label>
                      {errors.phone && (
                        <div className="invalid-feedback">{errors.phone}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <input
                        type="text"
                        className={`form-control ${
                          errors.subject ? "is-invalid" : ""
                        }`}
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        placeholder="Subject"
                        required
                      />
                      <label htmlFor="subject">Subject</label>
                      {errors.subject && (
                        <div className="invalid-feedback">{errors.subject}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <textarea
                        className={`form-control ${
                          errors.message ? "is-invalid" : ""
                        }`}
                        placeholder="Leave a message here"
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        style={{ height: "160px" }}
                        required
                      ></textarea>
                      <label htmlFor="message">Message</label>
                      {errors.message && (
                        <div className="invalid-feedback">{errors.message}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <button
                      type="submit"
                      className={`btn ${
                        isDisabled ? "disabled btn-dark" : "btn-primary"
                      } w-100 py-3`}
                      disabled={isDisabled}
                    >
                      {isSubmitting ? "Sending..." : "Send Message"}
                    </button>
                    {submitStatus && (
                      <div
                        className={`alert mt-3 ${
                          submitStatus.type === "success"
                            ? "alert-success"
                            : "alert-danger"
                        }`}
                      >
                        {submitStatus.message}
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="col-12 pt-5 wow zoomIn" data-wow-delay="0.1s">
            <div className="rounded h-100">
              <iframe
                title="map"
                className="rounded w-100"
                style={{ height: "800px" }}
                src={mapUrl}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
          {/* <div className="office pt-5">
            <div
              className="section-title text-center mb-5 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="sub-style">
                <h5 className="sub-title text-primary px-3">
                  Worlwide Offices
                </h5>
              </div>
              <h1 className="display-5 mb-4">Explore Our Office Worldwide</h1>
              <p className="mb-0">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat
                deleniti amet at atque sequi quibusdam cumque itaque repudiandae
                temporibus, eius nam mollitia voluptas maxime veniam
                necessitatibus saepe in ab? Repellat!
              </p>
            </div>
            <div className="row g-4 justify-content-center">
              <div
                className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
                data-wow-delay="0.1s"
              >
                <div className="office-item p-4">
                  <div className="office-img mb-4">
                    <h4 className="mb-2">Dhaka (Bangladesh)</h4>
                    <a href="#!" className="text-secondary fs-5 mb-2">
                      +8801852966938
                    </a>
                    <a href="#!" className="text-muted fs-5 mb-2">
                      butterflyairintl@gmail.com
                    </a>
                    <p className="mb-0">
                      Azad Center (3rd Floor), 55, Purana Paltan, Dhaka-1000,
                      Bangladesh
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
                data-wow-delay="0.3s"
              >
                <div className="office-item p-4">
                  <div className="office-img mb-4">
                    <img
                      src="img/office-1.jpg"
                      className="img-fluid w-100 rounded"
                      alt=""
                    />
                  </div>
                  <div className="office-content d-flex flex-column">
                    <h4 className="mb-2">Dhaka (Bangladesh)</h4>
                    <a href="#!" className="text-secondary fs-5 mb-2">
                      +8801852966938
                    </a>
                    <a href="#!" className="text-muted fs-5 mb-2">
                      butterflyairintl@gmail.com
                    </a>
                    <p className="mb-0">
                      Azad Center (3rd Floor), 55, Purana Paltan, Dhaka-1000,
                      Bangladesh
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
                data-wow-delay="0.5s"
              >
                <div className="office-item p-4">
                  <div className="office-img mb-4">
                    <img
                      src="img/office-3.jpg"
                      className="img-fluid w-100 rounded"
                      alt=""
                    />
                  </div>
                  <div className="office-content d-flex flex-column">
                    <h4 className="mb-2">Dhaka (Bangladesh)</h4>
                    <a href="#!" className="text-secondary fs-5 mb-2">
                      +8801852966938
                    </a>
                    <a href="#!" className="text-muted fs-5 mb-2">
                      butterflyairintl@gmail.com
                    </a>
                    <p className="mb-0">
                      Azad Center (3rd Floor), 55, Purana Paltan, Dhaka-1000,
                      Bangladesh
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
                data-wow-delay="0.7s"
              >
                <div className="office-item p-4">
                  <div className="office-img mb-4">
                    <img
                      src="img/office-4.jpg"
                      className="img-fluid w-100 rounded"
                      alt=""
                    />
                  </div>
                  <div className="office-content d-flex flex-column">
                    <h4 className="mb-2">Dhaka (Bangladesh)</h4>
                    <a href="#!" className="text-secondary fs-5 mb-2">
                      +8801852966938
                    </a>
                    <a href="#!" className="text-muted fs-5 mb-2">
                      butterflyairintl@gmail.com
                    </a>
                    <p className="mb-0">
                      Azad Center (3rd Floor), 55, Purana Paltan, Dhaka-1000,
                      Bangladesh
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 pt-5 wow zoomIn" data-wow-delay="0.1s">
                <div className="rounded h-100">
                  <iframe
                    title="map"
                    className="rounded w-100"
                    style={{ height: "800px" }}
                    src={mapUrl}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      {/* Contact End */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default Contact;
